// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#SideDetailsBrouillon {
  position: fixed;
  display: block;
  top: 65px;
  bottom: 0;
  right: -700px;
  width: 700px;
  z-index: 100;
  animation: SideDetailsBrouillonSlideLeft 0.4s forwards;
}
@keyframes SideDetailsBrouillonSlideLeft {
  from {
    width: 700px;
    right: -700px;
  }
  to {
    width: 700px;
    right: 0px;
  }
}
#SideDetailsBrouillon.hideOutside:before {
  content: "";
  background-color: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0;
  right: 700px;
  left: 0;
  bottom: 0;
  opacity: 0;
  animation: fadeIn 0.15s forwards;
  animation-delay: 0.4s;
}
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
#SideDetailsBrouillon.enlarge {
  animation: enlarge 0.15s forwards;
}
@keyframes enlarge {
  from {
    width: 700px;
    right: 0px;
  }
  to {
    width: calc(100% - 300px);
    right: 0px;
  }
}
#SideDetailsBrouillon.contract {
  animation: contract 0.15s forwards;
}
@keyframes contract {
  from {
    width: 100%;
    right: 0px;
  }
  to {
    width: 700px;
    right: 0px;
  }
}
#SideDetailsBrouillon .history-btn {
  position: absolute;
  left: -10px;
  z-index: 20;
  top: 3rem;
}
#SideDetailsBrouillon .history-container {
  width: 300px;
  position: absolute;
  left: -301px;
  top: 0;
  z-index: 10;
  height: 100%;
  overflow-x: auto;
}
#SideDetailsBrouillon .tab-pane {
  padding: 5px;
  margin: -5px;
}`, "",{"version":3,"sources":["webpack://./src/components/side-details/SideDetailsBrouillon.scss"],"names":[],"mappings":"AACA;EAKI,eAAA;EACA,cAAA;EACA,SAAA;EACA,SAAA;EACA,aAAA;EACA,YARgB;EAShB,YAAA;EACA,sDAAA;AAJJ;AAMI;EACI;IAAM,YAbM;IAaiB,aAAA;EAFnC;EAGM;IAAI,YAdQ;IAce,UAAA;EACjC;AACF;AAEQ;EACI,WAAA;EACA,oCAAA;EACA,eAAA;EACA,MAAA;EACA,YAvBQ;EAwBR,OAAA;EACA,SAAA;EACA,UAAA;EACA,gCAAA;EACA,qBAAA;AAAZ;AAEY;EACI;IAAM,UAAA;EACpB;EAAc;IAAI,UAAA;EAGlB;AACF;AACI;EACI,iCAAA;AACR;AACQ;EACI;IAAM,YAzCE;IAyCqB,UAAA;EAGvC;EAFU;IAAI,yBAAA;IAAmC,UAAA;EAMjD;AACF;AAHI;EACI,kCAAA;AAKR;AAHQ;EACI;IAAM,WAAA;IAAa,UAAA;EAO7B;EANU;IAAI,YAnDI;IAmDmB,UAAA;EAUrC;AACF;AAPI;EACI,kBAAA;EACA,WAAA;EACA,WAAA;EACA,SAAA;AASR;AANI;EACI,YA9DW;EA+DX,kBAAA;EACA,YAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;AAQR;AALI;EACI,YAAA;EACA,YAAA;AAOR","sourcesContent":["\n#SideDetailsBrouillon{\n\n    $contract-size: 700px;\n    $history-size: 300px;\n\n    position: fixed;\n    display: block;\n    top: 65px;\n    bottom: 0;\n    right: -$contract-size;\n    width: $contract-size;\n    z-index: 100;\n    animation: SideDetailsBrouillonSlideLeft .4s forwards;\n    \n    @keyframes SideDetailsBrouillonSlideLeft {\n        from {width: $contract-size; right: -$contract-size;}\n        to {width: $contract-size; right: 0px;}\n    }\n\n    &.hideOutside{\n        &:before{\n            content: \"\";\n            background-color: rgba(0, 0, 0, 0.5);\n            position: fixed;\n            top: 0;\n            right: $contract-size;\n            left: 0;\n            bottom: 0;\n            opacity: 0;\n            animation: fadeIn .15s forwards;\n            animation-delay: .4s;\n            \n            @keyframes fadeIn {\n                from {opacity: 0;}\n                to {opacity: 1;}\n            }\n        }\n    }\n\n    &.enlarge{\n        animation: enlarge .15s forwards;\n\n        @keyframes enlarge {\n            from {width: $contract-size; right: 0px}\n            to {width: calc(100% - $history-size); right: 0px}\n        }\n    }\n\n    &.contract{\n        animation: contract .15s forwards;\n\n        @keyframes contract {\n            from {width: 100%; right: 0px}\n            to {width: $contract-size; right: 0px}\n        }\n    }\n\n    .history-btn{\n        position: absolute;\n        left: -10px;\n        z-index: 20;\n        top: 3rem;\n    }\n\n    .history-container{\n        width: $history-size;\n        position: absolute;\n        left: (-$history-size)-1;\n        top: 0;\n        z-index: 10;\n        height: 100%;\n        overflow-x: auto;\n    }\n    \n    .tab-pane{\n        padding: 5px;\n        margin: -5px;\n    }\n\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
